<template>
  <router-view :key="$route.fullPath" />
</template>
<script>
/**
 * ==================================================================================
 * Auth layout
 * ==================================================================================
 **/

export default {}
</script>
